/**
 * Carga la lista de petshops (autoservicio) y da un helper para obtener el
 * nombre/QR/dueño de un petshop por su id. Reemplaza al viejo PETSHOPS fijo.
 */
import { useMemo } from 'react';

import { useFirestoreCollection } from '@/hooks/useFirestoreCollection';
import { petshopsQuery } from '@/services/firebase/petshops';
import { PETSHOPS, type Petshop } from '@/types/domain';

export interface PetshopMeta {
  id: string;
  nombre: string;
  corto: string;
  dueno?: string | null;
  telefono?: string | null;
  qrUrl?: string | null;
}

export function usePetshopsMeta() {
  const { data, loading } = useFirestoreCollection<Petshop>(petshopsQuery);

  const petshops = useMemo(
    () => [...data].sort((a, b) => (a.orden ?? 100) - (b.orden ?? 100)),
    [data],
  );

  const metaDe = (id: string): PetshopMeta => {
    const p = petshops.find((x) => x.id === id);
    if (p) {
      return { id: p.id, nombre: p.nombre, corto: p.nombreCorto || p.nombre, dueno: p.dueno, telefono: p.telefono, qrUrl: p.qrUrl };
    }
    const fb = PETSHOPS[id];
    return { id, nombre: fb?.nombre ?? id, corto: fb?.corto ?? id };
  };

  return { petshops, loading, metaDe };
}
